// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._16jlkb7n{flex-grow:1}\n._18m915vq{overflow-y:hidden}\n._19bvu2gc{padding-left:var(--ds-space-100,8px)}\n._1bto1l2s{text-overflow:ellipsis}\n._1o9zcs5v{flex-shrink:2}\n._1o9zidpf{flex-shrink:0}\n._1reo15vq{overflow-x:hidden}\n._o5721q9c{white-space:nowrap}\n._u5f3u2gc{padding-right:var(--ds-space-100,8px)}\n._y3gn1e5h{text-align:left}", ""]);
// Exports
module.exports = exports;
